import type { ChecklistDraftEntry } from '../fm-work-order-checklist.util';
import type { OutboxPhotoUploadOp, OutboxOp } from './wo-offline.models';

/** Collect PHOTO_UPLOAD ops from drafts that still have local files (stable order). */
export function photoOpsFromDrafts(drafts: Record<number, ChecklistDraftEntry>): OutboxPhotoUploadOp[] {
  const ops: OutboxPhotoUploadOp[] = [];
  for (const [orderKey, draft] of Object.entries(drafts)) {
    const order = Number(orderKey);
    const localPath = draft.localPhotoPath?.trim();
    if (!localPath || !Number.isFinite(order)) {
      continue;
    }
    ops.push({
      type: 'PHOTO_UPLOAD',
      order,
      localPath,
      contentType: 'image/jpeg',
    });
  }
  return ops.sort((a, b) => a.order - b.order);
}

/** Ensure photos run before SUBMIT in an outbox ops list. */
export function orderOutboxOps(ops: OutboxOp[]): OutboxOp[] {
  const photos = ops.filter((o): o is OutboxPhotoUploadOp => o.type === 'PHOTO_UPLOAD');
  const submits = ops.filter((o) => o.type === 'SUBMIT');
  photos.sort((a, b) => a.order - b.order);
  return [...photos, ...submits];
}
